module.exports = __webpack_public_path__ + "static/YangAnimsForMountain_FALL-a2aac11914fd73f2a73625c25f01c051.gif";